import { ApiLogsResponse } from './ApiLogsResonse';
import { LogTypes } from './LogTypes';
import {
  ContentType,
  HttpClient,
  RequestParams,
} from 'config/apiFunus/generated/http-client';
import { ServerNodes } from 'modules/backen-logs/api/LogsClient/ServerNodes';
import { LogsResonse } from 'modules/backen-logs/hooks/useLogs/LogsResonse';

export class LogsClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  fetchLogs = async (
    {
      type,
      lines,
      node,
    }: {
      type: LogTypes,
      lines: number,
      node: ServerNodes
    },
    params: RequestParams = {},
  ): Promise<LogsResonse> => this.http
    .request<ApiLogsResponse, void>({
      body: {
        lines,
        type,
      },
      headers: {
        'X-Custom-Node': node,
      },
      method: 'POST',
      path: '/logs',
      secure: true,
      type: ContentType.Json,
      ...params,
    })
    .then((response) => ({
      hostname: response.hostname,
      logs: response.content.split(/\r\n|\r|\n/),
    }))
}
